import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import { MdaiLink } from "../MdaiLink";

interface LinkDropdownProps {
  groupName: string;
  variant?: "text" | "outlined" | "contained";
  size?: "small" | "medium" | "large";
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  links: {
    label: string;
    href: string;
  }[];
}

export function LinkDropdown({
  groupName: grouplabel,
  variant,
  size,
  color,
  links,
}: LinkDropdownProps) {
  const [menuAnchorElement, setMenuAnchorElement] =
    useState<null | HTMLElement>(null);
  const open = Boolean(menuAnchorElement);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorElement(event.currentTarget);
  };
  const handleClose = () => {
    setMenuAnchorElement(null);
  };

  return (
    <>
      <Button
        variant={variant ?? "text"}
        size={size ?? "large"}
        color={color ?? "inherit"}
        onClick={handleClick}
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
      >
        {grouplabel}
      </Button>
      <Menu open={open} anchorEl={menuAnchorElement} onClose={handleClose}>
        {links.map(({ label, href }) => (
          <MenuItem key={label} onClick={handleClose}>
            <MdaiLink label={label} href={href} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
